import { MemberContactMethod, MemberMailerFrequency } from '@vista-digital/ocapi-types/v1';
export const mapMemberPreferences = (preferences) => {
    const { sites: { primarySiteId, preferredSiteIds }, genres: { preferredGenreIds }, contact: { contactMethods, mailerFrequency, allowThirdPartyContact }, allowThirdPartyProfiling } = preferences;
    const primarySite = primarySiteId || (preferredSiteIds.length > 0 ? preferredSiteIds[0] : '');
    return {
        primarySite,
        favouriteGenres: preferredGenreIds,
        newsletter: contactMethods.includes(MemberContactMethod.Email) && mailerFrequency !== MemberMailerFrequency.Never,
        allowThirdPartyContact,
        allowThirdPartyProfiling
    };
};
